import { App, View } from "@pimo/pimo-app-builder";
import { DragAndDropLayout, PMSmallTable } from "@pimo/pimo-components";
import { getLocalizedMessage } from "@pimo/pimo-l10n";

import { TestAppState } from "../../../app";
import { theme } from "../../../theme";
import { getProjectName } from "../../../utils/get-plural-of-project-name";

/** Adds the project team card (#2222). */
export function addProjectTeamCard(
  view: View<TestAppState, DragAndDropLayout>,
  app: App<TestAppState>
) {
  const state = app.getAppState();
  const language = state.language || "en";
  const { settings } = state;
  const projectName = getProjectName(
    settings?.configuration?.projectName,
    language
  );

  const projectTeamComponent = view.addComponent({
    component: PMSmallTable,
    layoutProps: {
      componentId: "projectTeamComponent",
      labels: ["team"],
      description:
        getLocalizedMessage(language, "descriptions.showsProjectTeam") ||
        "Shows the project Team.",
      title: `${projectName} ${getLocalizedMessage(language, "team") || "Team"}`,
    },
  });

  projectTeamComponent.mapState(({ currentReport, settings, language }) => {
    const localizedProjectName =
      getProjectName(settings?.configuration?.projectName, language) ||
      getLocalizedMessage(language, "project") ||
      "Project";

    return {
      showInfoIcon: false,
      showMenuIcon: false,
      icon: "InfoOutlined",
      title: `${localizedProjectName} ${getLocalizedMessage(language, "team") ?? "Team"}`,

      items: [
        {
          label: getLocalizedMessage(language, "owner") ?? "Owner",
          value: currentReport?.project?.owner ?? "",
          wrapValue: true,
          chipColor: theme.palette.secondary.main,
          chipTextColor: theme.palette.primary.main,
        },
      ],
      fixedHeight: "154px",
    };
  });

  projectTeamComponent.mapVisibility(
    ({ settings }) =>
      settings?.configuration?.fieldsDefinition
        ?.filter((field) => field.purpose === "projectBasic")
        ?.find((field) => field.fieldName === "owner")?.enabled === true
  );
}
